import { createContext, useContext, useState, type ReactNode } from 'react'

interface YearCtx {
  year: number
  setYear: (y: number) => void
  availableYears: number[]
}

const now = new Date().getFullYear()
const FIRST_YEAR = 2018
const DEFAULT_YEARS = Array.from({ length: now - FIRST_YEAR + 1 }, (_, i) => now - i)

const Ctx = createContext<YearCtx>({} as YearCtx)

export function YearProvider({ children }: { children: ReactNode }) {
  const [year, setYear] = useState<number>(now)
  // För utökning: alla år som finns sparade i localStorage kan hittas här senare
  const availableYears = DEFAULT_YEARS

  return (
    <Ctx.Provider value={{ year, setYear, availableYears }}>
      {children}
    </Ctx.Provider>
  )
}

export function useYear() {
  return useContext(Ctx)
}
